(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["content-notice"] && !Shopify.designMode) return;
  try {
    function initializeContentNotices(root = document) {
		root.querySelectorAll('[data-content-notice]').forEach((notice) => {
			if (notice.dataset.ready) return;
			notice.dataset.ready = 'true';
			const trigger = notice.querySelector('.content-notice__trigger');
			const dialog = notice.querySelector('dialog');
			const timer = setTimeout(() => { if (notice.isConnected) trigger.hidden = false; }, 15000);
			let previousOverflow;
			trigger.addEventListener('click', () => { previousOverflow = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden'; dialog.showModal(); });
			dialog.querySelector('.content-notice__close').addEventListener('click', () => dialog.close());
			dialog.addEventListener('click', (event) => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
			dialog.addEventListener('close', () => { document.documentElement.style.overflow = previousOverflow || ''; trigger.focus(); });
			document.addEventListener('shopify:section:unload', (event) => { if (event.target.contains(notice)) { clearTimeout(timer); if (dialog.open) dialog.close(); } });
		});
	}
	initializeContentNotices();
	document.addEventListener('shopify:section:load', (event) => initializeContentNotices(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["content-sidebar"] && !Shopify.designMode) return;
  try {
    function initializeContentPredictiveSearch(search) {
		if (search.dataset.predictiveReady === 'true') return
		const form = search.querySelector('[data-content-search-form]')
		const input = form?.querySelector('input[type="search"]')
		const results = search.querySelector('[data-content-search-results]')
		const status = search.querySelector('[data-content-search-status]')
		if (!form || !input || !results || !status) return

		let debounceTimer
		let requestController
		let activeIndex = -1

		const close = () => {
			results.hidden = true
			results.replaceChildren()
			input.setAttribute('aria-expanded', 'false')
			input.removeAttribute('aria-activedescendant')
			activeIndex = -1
			status.textContent = ''
		}

		const normalize = (value) => String(value || '')
			.toLocaleLowerCase('pt-BR')
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.replace(/[^a-z0-9\s/_-]/g, ' ')
			.replace(/[/_-]+/g, ' ')
			.replace(/\s+/g, ' ')
			.trim()
		const resultScore = (item, query) => {
			const title = normalize(item.title || '')
			if (title.startsWith(query)) return 0
			if (title.includes(query)) return 1
			return 2
		}

		const findLocalResults = (term) => {
			const index = window.SterilairContentSearchIndex
			const normalizedQuery = normalize(term)
			if (!Array.isArray(index) || !normalizedQuery) return null
			const terms = normalizedQuery.split(' ').filter(Boolean)

			return index.map((article) => {
				const title = normalize(article.title)
				const description = normalize(article.description)
				const routeTerms = (article.searchPath || '').replace(/^\/saiba-mais\//, '').replace(/\//g, ' ')
				const searchableText = normalize([article.title, article.description, routeTerms, ...(article.blocks || [])].filter(Boolean).join(' '))
				const matchingBlock = (article.blocks || []).some((block) => {
					const normalizedBlock = normalize(block)
					return terms.every((queryTerm) => normalizedBlock.includes(queryTerm))
				})
				if (!terms.every((queryTerm) => searchableText.includes(queryTerm))) return null

				let score = 0
				if (title.startsWith(normalizedQuery)) score += 8
				if (title.includes(normalizedQuery)) score += 5
				if (description.includes(normalizedQuery)) score += 2
				if (matchingBlock) score += 1
				score += terms.filter((queryTerm) => title.includes(queryTerm)).length * 2
				score += terms.filter((queryTerm) => searchableText.includes(queryTerm)).length
				return { article, score }
			})
				.filter(Boolean)
				.sort((left, right) => right.score - left.score || left.article.title.localeCompare(right.article.title, 'pt-BR'))
				.slice(0, 5)
				.map(({ article }) => article)
		}

		const render = (items, query) => {
			results.replaceChildren()
			if (!items.length) {
				const empty = document.createElement('p')
				empty.className = 'content-sidebar__search-empty'
				empty.textContent = `${search.dataset.noResults} “${input.value.trim()}”.`
				results.append(empty)
				status.textContent = empty.textContent
			} else {
				items.forEach((item, index) => {
					const link = document.createElement('a')
					link.id = `${results.id}-option-${index}`
					link.className = 'content-sidebar__search-result'
					link.href = item.url || item.href
					link.textContent = item.title
					link.setAttribute('role', 'option')
					link.setAttribute('aria-selected', 'false')
					results.append(link)
				})
				status.textContent = items.length === 1 ? search.dataset.resultSingular : `${items.length} ${search.dataset.resultPlural}`
			}
			results.hidden = false
			input.setAttribute('aria-expanded', 'true')
			activeIndex = -1
		}

		const fetchResults = async (term) => {
			const localResults = findLocalResults(term)
			if (localResults) {
				render(localResults, normalize(term))
				return
			}
			requestController?.abort()
			requestController = new AbortController()
			const url = new URL(search.dataset.predictiveUrl, window.location.origin)
			url.searchParams.set('q', term)
			url.searchParams.set('resources[type]', 'article,page')
			url.searchParams.set('resources[limit]', '10')
			url.searchParams.set('resources[limit_scope]', 'each')
			try {
				const response = await fetch(url, { signal: requestController.signal })
				if (!response.ok) throw new Error(`Predictive search: ${response.status}`)
				const data = await response.json()
				const resourceResults = data.resources?.results || {}
				const query = normalize(term)
				const items = [...(resourceResults.articles || []), ...(resourceResults.pages || [])]
					.sort((left, right) => resultScore(left, query) - resultScore(right, query) || left.title.localeCompare(right.title, 'pt-BR'))
					.slice(0, 5)
				render(items, query)
			} catch (error) {
				if (error.name !== 'AbortError') close()
			}
		}

		input.addEventListener('input', () => {
			clearTimeout(debounceTimer)
			const term = input.value.trim()
			if (!term) {
				requestController?.abort()
				close()
				return
			}
			debounceTimer = setTimeout(() => fetchResults(term), 250)
		})

		input.addEventListener('keydown', (event) => {
			const options = [...results.querySelectorAll('[role="option"]')]
			if (event.key === 'Escape') {
				close()
				return
			}
			if (!options.length || !['ArrowDown', 'ArrowUp'].includes(event.key)) return
			event.preventDefault()
			activeIndex = event.key === 'ArrowDown'
				? (activeIndex + 1) % options.length
				: (activeIndex - 1 + options.length) % options.length
			options.forEach((option, index) => option.setAttribute('aria-selected', String(index === activeIndex)))
			input.setAttribute('aria-activedescendant', options[activeIndex].id)
			options[activeIndex].scrollIntoView({ block: 'nearest' })
		})

		form.addEventListener('submit', (event) => {
			event.preventDefault()
			const active = results.querySelector('[role="option"][aria-selected="true"]')
			if (active) window.location.assign(active.href)
			else if (input.value.trim()) {
				clearTimeout(debounceTimer)
				fetchResults(input.value.trim())
			}
		})

		search.dataset.predictiveReady = 'true'
	}

	function initializeContentSidebarNavigation(navigation) {
		if (navigation.dataset.responsiveReady === 'true') return
		const desktop = window.matchMedia('(min-width: 992px)')
		const synchronize = () => {
			if (desktop.matches) navigation.setAttribute('open', '')
			else navigation.removeAttribute('open')
		}
		desktop.addEventListener('change', synchronize)
		synchronize()
		navigation.dataset.responsiveReady = 'true'
	}

	document.querySelectorAll('[data-content-sidebar-navigation]').forEach(initializeContentSidebarNavigation)
	document.querySelectorAll('[data-content-predictive-search]').forEach(initializeContentPredictiveSearch)
	document.addEventListener('shopify:section:load', (event) => {
		event.target.querySelectorAll('[data-content-sidebar-navigation]').forEach(initializeContentSidebarNavigation)
		event.target.querySelectorAll('[data-content-predictive-search]').forEach(initializeContentPredictiveSearch)
	})
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('purifier-testimonials-carousel')) {
		class PurifierTestimonialsCarousel extends HTMLElement {
			connectedCallback() {
				if (this.dataset.initialized === 'true') return
				this.dataset.initialized = 'true'

				var apiUrl = (this.dataset.apiUrl || '').replace(/\/$/, '').replace(/\/all-reviews(?:\?.*)?$/, '')
				if (!apiUrl) return

				var loading = this.querySelector('[data-testimonials-loading]')
				var track = this.querySelector('[data-testimonials-track]')
				var error = this.querySelector('[data-testimonials-error]')
				var template = this.querySelector('[data-testimonial-template]')
				loading.hidden = false

				fetch(apiUrl + '/store-reviews/carousel')
					.then(function (response) {
						if (!response.ok) throw new Error('Falha ao buscar o carrossel de avaliações')
						return response.json()
					})
					.then(function (payload) {
						var items = Array.isArray(payload) ? payload : (Array.isArray(payload && payload.value) ? payload.value : [])
						items = items.filter(function (item) {
							return item && ((item.text && item.text.trim()) || (item.name && item.name.trim()))
						})

						loading.hidden = true
						if (!items.length) return

						items.forEach(function (item) {
							var card = template.content.firstElementChild.cloneNode(true)
							var rawName = item.name && item.name.trim() ? item.name.trim() : 'Cliente Sterilair'
							var names = rawName.split(/\s+/)
							var formattedName = names.length === 1 ? names[0] : names[0] + ' ' + names[1].charAt(0).toUpperCase() + '.'
							var rating = Number(item.rating) || 5

							card.querySelector('[data-review-name]').textContent = formattedName
							card.querySelector('[data-review-text]').textContent = item.text && item.text.trim() ? item.text.trim() : 'Cliente avaliou mas não quis deixar comentários.'

							var ratingElement = card.querySelector('[data-review-rating]')
							ratingElement.setAttribute('aria-label', rating + ' de 5 estrelas')
							ratingElement.querySelectorAll('.icon-star').forEach(function (star, index) {
								var difference = rating - index
								if (difference <= 0) star.classList.add('is-empty')
								else if (difference < 1) star.classList.add('is-half')
							})

							if (item.created) {
								var date = new Date(item.created).toLocaleDateString('pt-BR', { timeZone: 'UTC' })
								card.querySelector('[data-review-date]').textContent = date
								card.querySelector('[data-review-date-wrap]').hidden = false
							}

							track.appendChild(card)
						})

						track.hidden = false
					})
					.catch(function () {
						loading.hidden = true
						error.hidden = false
					})
			}
		}

		customElements.define('purifier-testimonials-carousel', PurifierTestimonialsCarousel)
	}
  } catch(e) { console.error(e); }
})();

})();
